module.exports = __webpack_public_path__ + "static/media/046.deb0f09a.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/046.wav
 ** module id = 178
 ** module chunks = 0
 **/